export class Origin {
    constructor({
                    //attributes
                    id= null,
                    company_id= null,
                    name= '',
                    created_at= new Date(),
                    updated_at= new Date()
                } = {}) {

        this.id= id;
        this.company_id=company_id;
        this.name=name;
        this.created_at=created_at;
        this.updated_at=updated_at;


    }

}

export function createOrigin(data={}) {
    return Object.freeze(new Origin(data));
}